import React,{useEffect} from 'react'
import FrameComponents from '../FrameComponents';

const OrderList = () => {
  useEffect(()=>{
    document.title = 'DropshipMan-order-fulfillment';
  },[])
  return (
    <div>
      <FrameComponents name='order-fulfillment'/>
    </div>
  )
}

export default OrderList
